import React from 'react';
import { Card, Descriptions, List, Typography, Alert } from 'antd';
import { WarningOutlined, CheckCircleOutlined, UserOutlined } from '@ant-design/icons';
import { SaleData } from '../../SalesManager/types';
import { DuplicateInfo } from '../VendaModal';

const { Text } = Typography;

interface ReviewStepProps {
  data: Partial<SaleData>;
  duplicateInfo?: DuplicateInfo;
}

const ReviewStep: React.FC<ReviewStepProps> = ({ data, duplicateInfo }) => {
  const allProducts = [
    ...(data.selectedProducts || []),
    ...(data.additionalProducts || [])
  ];

  const getMatchedByText = (matchedBy?: 'phone' | 'email' | 'both') => {
    switch (matchedBy) {
      case 'phone': return 'telefone';
      case 'email': return 'email';
      case 'both': return 'telefone e email';
      default: return '';
    }
  };

  return (
    <div className="review-step">
      <div className="venda-step-header">
        <h4>Revisão da Venda</h4>
        <p>Confirme os dados antes de finalizar</p>
      </div>

      {/* Duplicate Warning */}
      {duplicateInfo?.found && duplicateInfo.existingLead && (
        <Alert
          message="Lead Existente Encontrado"
          description={
            <div>
              <p>
                <WarningOutlined style={{ color: '#faad14', marginRight: 8 }} />
                Foi encontrado um lead existente com o mesmo <strong>{getMatchedByText(duplicateInfo.matchedBy)}</strong>:
              </p>
              <div style={{ 
                backgroundColor: '#fffbe6', 
                padding: '8px 12px', 
                borderRadius: 4, 
                marginTop: 8,
                border: '1px solid #ffe58f'
              }}>
                <UserOutlined style={{ marginRight: 8 }} />
                <strong>{duplicateInfo.existingLead.name}</strong>
                {duplicateInfo.existingLead.phone && <span style={{ marginLeft: 16 }}>📞 {duplicateInfo.existingLead.phone}</span>}
                {duplicateInfo.existingLead.email && <span style={{ marginLeft: 16 }}>✉️ {duplicateInfo.existingLead.email}</span>}
              </div>
              <p style={{ marginTop: 8, fontSize: 12, color: '#8c8c8c' }}>
                A venda será associada a este lead existente.
              </p>
            </div>
          }
          type="warning"
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}

      {/* New Lead Info */}
      {!duplicateInfo?.found && !data.clientId && !data.leadId && (
        <Alert 
          message="Novo Lead" 
          description="Será criado um novo lead com estes dados e atribuído a si."
          type="success" 
          showIcon 
          icon={<CheckCircleOutlined />}
          style={{ marginBottom: 16 }}
        />
      )}

      <Card title="Informação do Cliente" size="small" style={{ marginBottom: 16 }}>
        <Descriptions column={2}>
          <Descriptions.Item label="Nome">{data.customerInfo?.name}</Descriptions.Item>
          <Descriptions.Item label="Email">{data.customerInfo?.email || '-'}</Descriptions.Item>
          <Descriptions.Item label="Telefone">{data.customerInfo?.phone}</Descriptions.Item>
          <Descriptions.Item label="Morada">{data.customerInfo?.address || '-'}</Descriptions.Item>
        </Descriptions>
      </Card>

      <Card title="Produtos Selecionados" size="small" style={{ marginBottom: 16 }}>
        <List
          itemLayout="horizontal"
          dataSource={allProducts}
          renderItem={item => (
            <List.Item>
              <List.Item.Meta
                title={item.product.name}
                description={
                  <span>Qtd: {item.quantity}</span>
                }
              />
              <div style={{ fontWeight: 'bold', color: '#10b981' }}>
                {(item.product.commission * item.quantity)} Pontos
              </div>
            </List.Item>
          )}
        />
        <div className="commission-total">
          <span className="commission-total-label">Pontos Totais</span>
          <span className="commission-total-value">{data.totalCommission?.toFixed(0)}</span>
        </div>
      </Card>
    </div>
  );
};

export default ReviewStep;


